/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBinary = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2c2.206 0 4 1.794 4 4a4.007 4.007 0 0 1-3 3.873V11h6v3.127c1.724.445 3 2.012 3 3.873 0 2.206-1.794 4-4 4s-4-1.794-4-4a4.007 4.007 0 0 1 3-3.874V13H7v1.127c1.724.445 3 2.012 3 3.873 0 2.206-1.794 4-4 4s-4-1.794-4-4a4.007 4.007 0 0 1 3-3.874V11h6V9.874A4.007 4.007 0 0 1 8 6c0-2.206 1.794-4 4-4zM6 16c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm12 0c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zM12 4c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBinary as Binary };
